import PropTypes from 'prop-types';
import React from 'react';
import { List } from 'immutable';
import _ from 'lodash';

import Search from '../../records/Search';
import SeasonSearch from '../../records/SeasonSearch';
import { translate as t } from '../../lib/I18n';
import { unique } from '../../helpers/Immutable';
import StationStore from '../../stores/StationStore';
import TrackingActions from "../../actions/TrackingActions";

import PureRenderComponent from '../PureRenderComponent';
import Select from '../form/Select';

class JourneySelectorClosed extends PureRenderComponent {

    static propTypes = {
        search: PropTypes.oneOfType([
            PropTypes.instanceOf(Search),
            PropTypes.instanceOf(SeasonSearch)
        ]).isRequired,
        onChange: PropTypes.func,
        options: PropTypes.instanceOf(List),
        showAdditionalRoutes: PropTypes.bool
    };

    static defaultProps = {
        showAdditionalRoutes: false
    };

    state = {
        journeys: new List()
    };

    UNSAFE_componentWillMount () {
        const { options } = this.props;
        if (options && options.size > 0) {
            this.updateJourneys(options);
        }
    }

    UNSAFE_componentWillReceiveProps (nextProps) {
        if (nextProps.options &&
                this.props.search.showAdditionalRoutes !== nextProps.search.showAdditionalRoutes) {
            this.updateJourneys(nextProps.options);
        }
    }

    updateJourneys = async (options) => {
        // Find out the stations CRS codes we need to fetch and ask the store for them
        const stationCrsCodes = unique(options.flatten(true), (crs) => crs);
        const stationPromises = stationCrsCodes.map((crs) => StationStore.get(crs));
        const stations = await Promise.all(stationPromises.toArray());

        // Once we have the stations, we need to construct the given journey options
        // again - but using the actual station records we have been given back rather
        // than just the CRS codes since we need more detail information about the stations
        const byCRS = (crs) => stations.find((station) => station.get('crs') === crs);
        const updatedJourneys = options.map((option) => option.map(byCRS));
        this.setState({ journeys: updatedJourneys });
    };

    _handleChange = (event) => {
        const { search, onChange } = this.props;
        const [ origin, destination ] = this.state.journeys
            .get(event.target.selectedIndex - 1)
            .toArray();

        TrackingActions.widgetSearchClick({ name: `direction:${event.target.value.toLowerCase()}` });

        return onChange(search.set('origin', origin).set('destination', destination));
    };

    render () {
        const value = _.compact([
            this.props.search.origin.get('crs'),
            this.props.search.destination.get('crs')
        ]).join('-');

        return (
            <section className="booking__section">
                <div className="form-field journey-selector__closed">
                    <Select
                        id="journey"
                        type="select"
                        value={ value }
                        labelClassName="sr-only"
                        className="journey-selector"
                        onChange={ this._handleChange }
                        groupClassName="select-container"
                        label={ t('booking.journey.chooseAJourney') }>
                            <option value="" disabled>{ t('booking.journey.chooseAJourney') + '...' }</option>
                            { this.state.journeys.map((option, key) => {
                                const [ origin, destination ] = option.toArray();
                                if (origin && destination) {
                                    return (
                                        <option
                                            key={ key }
                                            value={ origin.get('crs') + '-' + destination.get('crs') }>
                                            { origin.getName() } { t('global.to') } { destination.getName() }
                                        </option>
                                    );
                                }
                                return null;
                            }) }
                    </Select>
                </div>
            </section>
        );
    }
}

export default JourneySelectorClosed;



// WEBPACK FOOTER //
// ./src/components/search/JourneySelectorClosed.js